// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1nm4c","error":"Textarea_error__2RSM3","readonly":"Textarea_readonly__1yB_H","disabled":"Textarea_disabled__1_q6a"};